import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { MgsaForEditorFragmentDoc } from '../../fragments/generated/mgsaForEditor';
import { MgsaDraftStateFragmentDoc } from '../../fragments/generated/mgsaDraft';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type MgsaForEditorQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.MgsaFilters>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type MgsaForEditorQuery = { mgsas: { edges?: Array<{ node: { id: string, entityId: string, entityType: Types.MgsaEntityTypeEnum, orgRoleId?: string | null, status: Types.MgsaStatusEnum, updatedAt: string, draftState?: { mindsets?: Array<{ name: string, description?: string | null }> | null, goals?: Array<{ name: string, description?: string | null }> | null, skillGroups?: Array<{ skillGroupName: string, skills: Array<{ description?: string | null, expectedScore: number, name: string, reviewerScore: number }> }> | null, activities?: Array<{ activityEntityId?: string | null, activityType: Types.MgsaActivityTypeEnum, description?: string | null, draftOkr?: string | null }> | null, overriddenMgsaPropertiesConfig?: { skillOverridden?: boolean | null, mindsetOverridden?: boolean | null, goalOverridden?: boolean | null, activityOverridden?: boolean | null } | null } | null } }> | null } };


export const MgsaForEditorDocument = /*#__PURE__*/ gql`
    query mgsaForEditor($filters: MgsaFilters, $first: Float) {
  mgsas(filters: $filters, first: $first) {
    edges {
      node {
        ...MgsaForEditor
      }
    }
  }
}
    ${MgsaForEditorFragmentDoc}
${MgsaDraftStateFragmentDoc}`;

export function useMgsaForEditorQuery(options?: Omit<Urql.UseQueryArgs<MgsaForEditorQueryVariables>, 'query'>) {
  return Urql.useQuery<MgsaForEditorQuery, MgsaForEditorQueryVariables>({ query: MgsaForEditorDocument, ...options });
};